import * as React from "react";
import { useParams } from 'react-router';
import DrawerPhotoList from "../../common/DrawerPhotoList.jsx";
import DrawerButton from "../../common/DrawerButton";
import ImageCache from "../../common/ImageCache";

const Comp = ({ images }: any) => {

    const { noBatch, noImage } = useParams<any>();
    const [openDrawer, setOpenDrawer] = React.useState(false);

    const toggleDrawer = () => setOpenDrawer(!openDrawer)

    const imagesWithLabelOrMotif = images.filter((img: any) => img.labels.polygonLabels.length > 0 || img.motif !== null);

    return (
        <>
            {Number(noImage) >= images.length && (
                <ImageCache images={images} noImageToCache={Number(noImage) + 1} />
            )}
            {openDrawer && (
            <DrawerPhotoList
                open={openDrawer}
                images={imagesWithLabelOrMotif}
                noBatch={noBatch}
                noImage={noImage}
                labelingTypePathname="labelerSegmentation"
            />
            )}
            {imagesWithLabelOrMotif.length > 1 && (
            <DrawerButton
                onClick={toggleDrawer}
                drawerOpen={openDrawer}
            />
            )}
        </>
    )
}

export default Comp;